export default __webpack_public_path__ + "static/media/truck.655bca17.svg";